var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('phase-templates',{attrs:{"project-phases":_vm.project_phases,"service-levels":_vm.service_levels,"editable":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }